require('./contractPayrollLoan.scss');
// @vendor
const React = require('react');
const { withRouter } = require("react-router-dom");
const PropTypes = require('prop-types');
// @common
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @components
const ContractLoanTooltip = require('../../contractLoanTooltip/contractLoanTooltip');
const PayrollLoanCompilationCard = require('../../contractPayrollLoan/payrollLoanCompilationCard/payrollLoanCompilationCard');
const ContractPayrollLoanStepOne = require('../../contractPayrollLoan/contractPayrollLoanStepOne/contractPayrollLoanStepOne');
const ContractPayrollLoanStepTwo = require('../../contractPayrollLoan/contractPayrollLoanStepTwo/contractPayrollLoanStepTwo');
const PayrollLoanRequestError = require('../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestError/payrollLoanRequestError');
const ContractLoanSuccess = require('../../contractLoanSuccess/contractLoanSuccess');
const PayrollLoanKOxDTI = require('../../contractPayrollLoan/payrollLoanKOxDTI/payrollLoanKOxDTI');
// @core
const { formatText, FormattedText } = require('core/i18n').i18n;
const { scrollToTop } = require('commonsUtilities/scrollUtils');
//@utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getCollectiveByParams } = require('utilities/collectivesHelper');
// @constants
const {
    multichannelAlias: { PAYROLL_LOAN_ALIAS },
    payrollLoanRecordStatus: { contractStatus }
} = require('../../../../loansConstants/index');
const {
    PERSONAL_LOAN_DRAGO
} = require('constants/flagBasedFeatures');
const { MULTICHANNEL_UI_COMPONENT } = require('constants/index');
const { NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class ContractPayrollLoan extends React.Component {
    constructor(props) {
        super(props);

        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.dropRecord = this.dropRecord.bind(this);
        this.hideNewOfferView = this.hideNewOfferView.bind(this);
    }

    componentDidMount() {
        const { setContractLoanAccountsInactive, contractInitialize, immAccounts,
            immCollectives, getCollectiveInfo, setCurrentProductCollective } = this.props;
        const immCollectivesInfo = immCollectives.get('collectivesInfo');
        const inactiveAccounts = immAccounts.get('blockedAccountsOrNegativeAll');
        const activeItem = getCollectiveByParams(PAYROLL_LOAN_ALIAS, null, immCollectivesInfo);

        if (inactiveAccounts) {
            setContractLoanAccountsInactive();
        } else {
            getCollectiveInfo([
                { alias: PAYROLL_LOAN_ALIAS },
            ], MULTICHANNEL_UI_COMPONENT);

            if (activeItem) {
                const title = activeItem.get('title') || '';
                setCurrentProductCollective({ title });
            }

            contractInitialize();
        }

        scrollToTop();
    }

    componentDidUpdate(prevProps) {
        const oldStatus = prevProps.immContractPayrollLoan.get('preApprovalState');
        const newStatus = this.props.immContractPayrollLoan.get('preApprovalState');
        const error = this.props.immContractPayrollLoan.get('errorContractInitialize');

        if (oldStatus !== newStatus) {
            if (error || this.getIsDenied()) {
                this.props.history.push('/myprofile/loans-mortgages');
            }
        }
    }

    componentWillUnmount() {
        const { resetState, segmentedLoanProductsReset } = this.props;

        resetState();
        segmentedLoanProductsReset();
    }

    getIsDenied() {
        const { immContractPayrollLoan } = this.props;
        const status = immContractPayrollLoan.get('preApprovalState');
        const initialized = immContractPayrollLoan.get('initialized');
        const isContract = Object.values(contractStatus).includes(status);

        return initialized && !isContract;
    }

    hideNewOfferView() {
        this.props.hideNewOfferView();
    }

    dropRecord() {
        const { immContractPayrollLoan } = this.props;
        const recordId = immContractPayrollLoan.get('recordId');
        this.props.cancelLoanRecord(recordId);
        this.props.history.push('/myprofile/loans-mortgages');
    }

    buildSidebar(taeTooltipElement, isNewOffer) {
        const {
            immAccounts,
            immFlagBasedFeatures,
            immContractPayrollLoan,
            location,
        } = this.props;

        const selectedAccount = immContractPayrollLoan.get('selectedAccount');
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const isCollective = immContractPayrollLoan.get('isCollective');
        const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);

        let nodataNewOffer = undefined;
        let callKOxDTI = undefined;
        let taeTooltip = undefined;

        if (isNewOffer) {
            nodataNewOffer = !immContractPayrollLoan.getIn(['newOffer', 'seletedAmountOrTerm']);
            callKOxDTI = true;
        }

        if (!nodataNewOffer) {
            taeTooltip = taeTooltipElement;
        }

        return (
            <div className="col-xs-4">
                <PayrollLoanCompilationCard
                    immAccount={immAccount}
                    immStep={immContractPayrollLoan}
                    taeTooltip={taeTooltip}
                    nodataKOxDTI={nodataNewOffer}
                    callKOxDTI={callKOxDTI}
                    isCollective={isCollective}
                    location={location}
                    isDragoFeature={isDragoFeature}
                />
            </div>
        );
    }

    buildContent() {
        const {
            immContractPayrollLoan,
            immFlagBasedFeatures,
            cancelLoanRecord,
            getInstallment,
            setLoanAmountNewOffer,
            setLoanTermNewOffer,
            getMinTerm,
        } = this.props;

        const nodataNewOffer = !immContractPayrollLoan.getIn(['newOffer', 'seletedAmountOrTerm']);
        const taeTooltip = this.buildTaeTooltip();
        const isNewOffer = immContractPayrollLoan.get('showNewOfferView');
        const isCollective = immContractPayrollLoan.get('isCollective');
        const sidebar = this.buildSidebar(taeTooltip, isNewOffer);
        let mainContent;

        if (isNewOffer) {
            mainContent = (
                <PayrollLoanKOxDTI
                    immPayrollLoan={immContractPayrollLoan}
                    cancelLoanRecord={cancelLoanRecord}
                    hideNewOfferView={this.hideNewOfferView}
                    taeTooltip={taeTooltip}
                    getInstallment={getInstallment}
                    setLoanAmount={setLoanAmountNewOffer}
                    setLoanTerm={setLoanTermNewOffer}
                    getMinTerm={getMinTerm}
                    isNewOffer={isNewOffer}
                    nodataKOxDTI={nodataNewOffer}
                    isCollective={isCollective}
                    isDragoFeature={immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO)}
                />
            );
        } else {
            mainContent = this.buildWizard(taeTooltip);
        }

        return (
            <div className="row">
                <div className="col-xs-8">
                    {mainContent}
                </div>
                {sidebar}
            </div>
        );
    }

    buildStepOne(taeTooltip) {
        const {
            getBlockedAccounts,
            getInstallment,
            getMinTerm,
            immAccounts,
            immContractPayrollLoan,
            immFlagBasedFeatures,
            setLoanAmount,
            setLoanTerm,
            setPaymentDay,
            setSelectedAccount
        } = this.props;
        const initialized = immContractPayrollLoan.get('initialized');

        return initialized ? (
            <ContractPayrollLoanStepOne
                getBlockedAccounts={getBlockedAccounts}
                getInstallment={getInstallment}
                getMinTerm={getMinTerm}
                immAccounts={immAccounts}
                immContractPayrollLoan={immContractPayrollLoan}
                immFlagBasedFeatures={immFlagBasedFeatures}
                setLoanAmount={setLoanAmount}
                setLoanTerm={setLoanTerm}
                setPaymentDay={setPaymentDay}
                setSelectedAccount={setSelectedAccount}
                taeTooltip={taeTooltip}
            />
        ) :
            (
                <LoadingSection />
            );
    }

    buildStepTwo() {
        const {
            downloadINEDocument,
            downloadLoanContractDocument,
            getHiringDocuments,
            getProposition,
            immAccounts,
            immFlagBasedFeatures,
            immContractPayrollLoan,
            immProfile,
            onDownloadDocument,
            onPrintDocument,
            preContractualMail,
            requestProfile,
            resetDocumentsAndAgreeCheckBox,
            resetPrecontractualMail,
            sendMail,
            setAgree,
            printedAndSignedRadioChanged,
            enableButtonOffice,
            immPrinter,
            checkReadDocument,
            checkRadioButton,
            checkCheckedDocument
        } = this.props;

        return (
            <ContractPayrollLoanStepTwo
                downloadINEDocument={downloadINEDocument}
                downloadLoanContractDocument={downloadLoanContractDocument}
                getHiringDocuments={getHiringDocuments}
                getProposition={getProposition}
                immAccounts={immAccounts}
                immPayrollLoan={immContractPayrollLoan}
                immProfile={immProfile}
                onDownloadDocument={onDownloadDocument}
                onPrintDocument={onPrintDocument}
                preContractualMail={preContractualMail}
                requestProfile={requestProfile}
                resetDocumentsAndAgreeCheckBox={resetDocumentsAndAgreeCheckBox}
                resetPrecontractualMail={resetPrecontractualMail}
                sendMail={sendMail}
                setAgree={setAgree}
                isDragoFeature={immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO)}
                immFlagBasedFeatures={immFlagBasedFeatures}
                printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                enableButtonOffice={enableButtonOffice}
                immPrinter={immPrinter}
                checkReadDocument={checkReadDocument}
                checkRadioButton={checkRadioButton}
                checkCheckedDocument={checkCheckedDocument}
            />
        );
    }

    buildSuccess() {
        const {
            immContractPayrollLoan,
            immFlagBasedFeatures,
            immProfile,
        } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);

        return (
            <div className="contract-payroll-loan__success row">
                <ContractLoanSuccess
                    immData={immContractPayrollLoan}
                    isDragoFeature={isDragoFeature}
                    viewToRender={"contract-payroll-loan"}
                    email={email}
                />
            </div>
        );

    }

    buildTaeTooltip() {
        const { immContractPayrollLoan } = this.props;

        return (
            <ContractLoanTooltip
                immContractLoan={immContractPayrollLoan}
                clarifyingText="clarifyingText"
            />
        );
    }

    builDisclaimerText() {
        return (
            <div className="contract-payroll-loan__superscript-info">
                <FormattedText
                    value="contractEasyLoanStepOne-contractEasyLoanStepOne_superscriptInfo"
                />
            </div>
        )
    }

    buildWizard(taeTooltip) {
        const { immContractPayrollLoan, validateStep, setVisibleStep, immFlagBasedFeatures } = this.props;
        const immSteps = immContractPayrollLoan.get('steps');
        const isFetchingStepTwo = immContractPayrollLoan.get('isFetchingFormalize') || immContractPayrollLoan.get('isFetchingDocuments');
        const visibleStep = immContractPayrollLoan.get('visibleStep');
        const checkedRadioButton = immContractPayrollLoan.get('checkedRadioButton');
        const stepsAmount = immSteps.size;
        const showPreLeaveModal = !this.getIsDenied();
        const stepOneComponent = this.buildStepOne(taeTooltip);
        const stepTwoComponent = this.buildStepTwo();

        const actions = {
            finish: this.handleFinish,
            cancel: this.handleCancel,
            validateStep,
            setVisibleStep,
            setWillCancel: () => { return false; },
            setWillGoBack: () => { return false; },
            resetStep: () => { return false; }
        };

        const preleaveModalMessage = formatText('payrollLoanRequest-modalLeaveText');
        const preleaveModalTitle = formatText('payrollLoanRequest-modalLeaveTitle');

        const preleaveModalLeftButtonConfig = {
            text: formatText('payrollLoanRequest-modalLeaveButton'),
            redirect: true,
            callback: this.dropRecord
        };

        const preleaveModalRightButtonConfig = {
            text: formatText('payrollLoanRequest-continueLater'),
            redirect: true
        };
        const disclaimerText = this.builDisclaimerText();
        const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES)
        const documentsPrintedAndSigned = this.props.immPrinter.get('documentsPrintedAndSigned')

        return (
            <React.Fragment>
                <Wizard
                    immSteps={immSteps}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    actions={actions}
                    preleaveModalMessage={preleaveModalMessage}
                    preleaveModalTitle={preleaveModalTitle}
                    preleaveModalLeftButtonConfig={preleaveModalLeftButtonConfig}
                    preleaveModalRightButtonConfig={preleaveModalRightButtonConfig}
                    showPreLeaveModal={showPreLeaveModal}
                >
                    <WizardStep
                        nextButton
                        position="first"
                        cancelButtonText={formatText('payrollLoanRequest-leaveButton')}
                        cancelButton
                    >
                        {stepOneComponent}
                    </WizardStep>
                    <WizardStep
                        position="last"
                        finalButtonDisabled={!immContractPayrollLoan.get('agree') || (newPayrollLoanFF && __CONTACT_CENTER__ && isPrintOfficeMode() && documentsPrintedAndSigned !== 'YES')}
                        immFinalButton="contractPayrollLoanStepTwo-ctaButton"
                        cancelButtonText={formatText('payrollLoanRequest-leaveButton')}
                        isLoading={isFetchingStepTwo}
                        addLoadingBehaviour
                        cancelButton
                    >
                        {stepTwoComponent}
                    </WizardStep>
                </Wizard>
                {disclaimerText}
            </React.Fragment>
        );
    }

    handleCancel() {
        this.props.history.push('/myprofile/loans-mortgages');
    }

    handleFinish() {
        //Double Click on CallToAction button. Wizard Component known-issue.
        const { immContractPayrollLoan, validateStep, formalize, preContractualMail, immFlagBasedFeatures } = this.props;
        const visibleStep = immContractPayrollLoan.get('visibleStep');
        const agreeCheckbox = immContractPayrollLoan.get('agree');
        const mailSent = preContractualMail.get('mailSent');
        const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES)
        if (newPayrollLoanFF && (__CONTACT_CENTER__ || isPrintOfficeMode())) {
            formalize()
        }
        if (!__CONTACT_CENTER__ || (__CONTACT_CENTER__ && mailSent)) {
            if (!agreeCheckbox) {
                validateStep(visibleStep);
            }
            else {
                formalize()
            }
        }
    }

    render() {
        let content;
        const { immContractPayrollLoan } = this.props;
        const success = immContractPayrollLoan.get('submitSuccessful');
        const error = immContractPayrollLoan.get('error');

        const showLoading = immContractPayrollLoan.get('isFetching');

        if (showLoading) {
            content = <LoadingSection />;
        } else if (success) {
            content = this.buildSuccess();
        } else if (error) {
            content = <PayrollLoanRequestError />;
        } else {
            content = this.buildContent();
        }

        return (
            <div className="row">
                {content}
            </div>
        );
    }
}

ContractPayrollLoan.propTypes = {
    cancelLoanRecord: PropTypes.func.isRequired,
    contractInitialize: PropTypes.func.isRequired,
    downloadINEDocument: PropTypes.func.isRequired,
    downloadLoanContractDocument: PropTypes.func.isRequired,
    formalize: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getCollectiveInfo: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    getMinTerm: PropTypes.func.isRequired,
    getProposition: PropTypes.func.isRequired,
    hideNewOfferView: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immCollectives: PropTypes.object.isRequired,
    immContractPayrollLoan: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    location: PropTypes.object,
    onDownloadDocument: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetDocumentsAndAgreeCheckBox: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetState: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    segmentedLoanProductsReset: PropTypes.func.isRequired,
    setAgree: PropTypes.func.isRequired,
    setContractLoanAccountsInactive: PropTypes.func.isRequired,
    setCurrentProductCollective: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanAmountNewOffer: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setLoanTermNewOffer: PropTypes.func.isRequired,
    setPaymentDay: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(ContractPayrollLoan);
